import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ImpersonatedBuyer } from '../../models/impersonation.model';
import { Buyer } from '@ps/core-models';

export const ImpersonationActions = createActionGroup({
  source: 'Impersonation',
  events: {
    Connect: props<Buyer>(),
    'Connect Success': props<{ buyerCompany: ImpersonatedBuyer }>(),
    'Connect Failure': props<{ error: string }>(),
    Disconnect: emptyProps(),
    'Disconnect Success': emptyProps(),
    'Switch Buyer': props<Buyer>(),
    'Context Settled': props<{
      companyId: number;
      hasImpersonatedBuyer: boolean;
    }>(),
    Rehydrate: props<{ buyerCompany: ImpersonatedBuyer }>(),
  },
});
